module.exports = __webpack_public_path__ + "img/no-imagen-producto.3ff6f896.jpg";